@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="updateEmailForm" (ngSubmit)="onSubmit()">
  <div class="update-email-form">
    <bmcore-input
      formControlName="email"
      [title]="'New email'"
      [type]="'email'"
      [className]="'edit-profile'"
      [controlFormName]="'email'"
    >
    </bmcore-input>
    <bmcore-input
      formControlName="password"
      [title]="'Password'"
      [type]="'password'"
      [className]="'edit-profile'"
      [controlFormName]="'password'"
    >
    </bmcore-input>
  </div>

  <div class="update-email-form__btn">
    <bmcore-button title="Save" styleName="right" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
